module.exports = __webpack_public_path__ + "img/li1.46ea2f41.png";